<template>
    <div class="flex flex_center secondary_color" style="height:400px">
        {{$t('dashboard.statistics.empty')}}
    </div>
</template>
<script>
export default {
	props: {
		style: {type: String, default: null}
    }
}
</script>